import React, { useState, useEffect, useContext } from "react";
import { gql, useQuery } from "@apollo/client";
import StarekContext from "../context/StarekContext";
import ProductionReport from "../pages/report/ProductionReport";

const GET_SHIFT_LIST_FOR_PLANT = gql`
    query GetShifts($plantId: Int!) {
        shifts(where: { plant_id: { equals: $plantId } }) {
            id
            name
            description
            start_time
            end_time
            runs_on
            created_at
        }
    }
`;

function EfficiencyMonitor(props) {
    const { lastUsedPlant } = useContext(StarekContext);
    const [activeTab, setActiveTab] = useState("running");
    const [filters, setFilters] = useState({});
    const [range, setRange] = useState([0, 0]);

    const { data: shiftData } = useQuery(GET_SHIFT_LIST_FOR_PLANT, {
        variables: { plantId: lastUsedPlant?.id },
        skip: !lastUsedPlant?.id,
    });

    useEffect(() => {
        if (!shiftData?.shifts || !props.deviceData?.shadowDevices) return;

        const now = new Date();
        const todayStr = now.toISOString().slice(0, 10);

        const yesterday = new Date(now);
        yesterday.setDate(yesterday.getDate() - 1);
        const yesterdayStr = yesterday.toISOString().slice(0, 10);

        const currentSeconds =
            now.getHours() * 3600 + now.getMinutes() * 60 + now.getSeconds();
        const completedShifts = shiftData.shifts.filter((shift) => {
            return (
                shift.end_time < currentSeconds &&
                shift.start_time < shift.end_time
            );
        });

        let targetShift = null;
        let selectedDateStr = todayStr;

        if (activeTab === "running") {
            targetShift = shiftData.shifts.find((shift) => {
                if (shift.start_time < shift.end_time) {
                    return (
                        currentSeconds >= shift.start_time &&
                        currentSeconds <= shift.end_time
                    );
                } else {
                    return (
                        currentSeconds >= shift.start_time ||
                        currentSeconds <= shift.end_time
                    );
                }
            });
            //  if (!targetShift && shiftData.shifts.length > 0) {
            //  }
        } else {
            if (completedShifts.length > 0) {
                completedShifts.sort((a, b) => b.end_time - a.end_time);
                targetShift = completedShifts[0];
                selectedDateStr = todayStr;
            } else {
                if (shiftData.shifts.length > 0) {
                    targetShift = shiftData.shifts[shiftData.shifts.length - 1];
                    selectedDateStr = yesterdayStr;
                }
            }
        }

        if (targetShift) {
            let diff = targetShift.end_time - targetShift.start_time;
            if (diff < 0) diff += 86400;

            const base = new Date(selectedDateStr);
            const startDate = new Date(base);
            const endDate = new Date(base);

            startDate.setSeconds(targetShift.start_time);
            endDate.setSeconds(targetShift.end_time);

            if (targetShift.end_time < targetShift.start_time) {
                endDate.setDate(endDate.getDate() + 1);
            }
            const newFilters = {
                devices: props.deviceData.shadowDevices
                    .map((d) => d.id)
                    .join(","),
                duration: `shift_${targetShift.id}`,
                shiftDate: selectedDateStr,
                durationStart: startDate.toISOString(),
                durationEnd: endDate.toISOString(),
                durationSeconds: diff,
            };

            setFilters(newFilters);
            setRange([0, diff]);
        }
    }, [shiftData, props.deviceData, activeTab]);

    return (
        <div className="card" style={{ height: "400px" }}>
            <div
                className="card-header ui-sortable-handle"
                style={{ cursor: "move" }}
            >
                <h3 className="card-title">
                    <i className="fas fa-clipboard mr-1" />
                    Live Production Monitor
                </h3>
                <div className="card-tools">
                    <ul className="nav nav-pills ml-auto">
                        <li className="nav-item">
                            <a
                                className={`nav-link ${
                                    activeTab === "running" ? "active" : ""
                                }`}
                                href="#revenue-chart"
                                data-toggle="tab"
                                onClick={(e) => {
                                    e.preventDefault();
                                    setActiveTab("running");
                                }}
                            >
                                Running Shift
                            </a>
                        </li>
                        <li className="nav-item">
                            <a
                                className={`nav-link ${
                                    activeTab === "completed" ? "active" : ""
                                }`}
                                href="#sales-chart"
                                data-toggle="tab"
                                onClick={(e) => {
                                    e.preventDefault();
                                    setActiveTab("completed");
                                }}
                            >
                                Last Completed Shift
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="card-body">
                <ProductionReport
                    deviceData={props.deviceData}
                    filters={filters}
                    range={range}
                    hideControls={true}
                />
            </div>
        </div>
    );
}

export default EfficiencyMonitor;
